<template>
	<div class='text-sm leading-6 mb-10'>

		<h2 class="text-xl font-bold leading-5 text-red-700 mt-4 mb-4">Terms and Conditions
            <a class="hover:underline" href="/contract" target="_blank" rel="noopener">
              <svg class="inline-block ml-2 -mt-1" width="18" height="18" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
		</h2>
		<h3 class="text-lg font-bold leading-5 text-red-700 mt-4 mb-4">Conditions of Membership Agreement</h3>

		<div class="space-y-8">
			<div>
				<p class="mb-4">The Broker Site B.V. (hereinafter: "The Broker Site") (also referred to as 'Platform' and 'we') is a B2B-marketplace that allows users to offer, sell, and purchase computers, laptops, servers, mobiles and all other related parts and equipment. The Broker Site itself is not a party to sales contracts concluded between users.</p>
			</div>

			<div>
				<h2 class="text-lg font-bold text-gray-800 mb-3">1. Definitions</h2>
				<div class="space-y-2 ml-4">
					<p><strong>Advertising Party/Member:</strong> any User that is offering products via the Platform.</p>
					<p><strong>Platform:</strong> the online marketplace operated by The Broker Site.</p>
					<p><strong>Service:</strong> the facilitation of transactions between Users through the Platform.</p>
					<p><strong>Terms:</strong> this document.</p>
					<p><strong>User:</strong> any individual or business entity registered on the Platform.</p>
				</div>
			</div>

			<div>
				<h2 class="text-lg font-bold text-gray-800 mb-3">2. Applicability</h2>
				<div class="space-y-2 ml-4">
					<div class="flex">
						<span class="font-medium mr-2">2.1</span>
						<span>These Terms apply to all use of the Platform by Users.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">2.2</span>
						<span>The Broker Site acts solely as an intermediary and is not a contracting party to any transaction between Users.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">2.3</span>
						<span>The Broker Site does not own or control any of the products offered and does not guarantee their quality, legality, conformity or delivery. While The Broker Site may carry out verification checks, it cannot guarantee the reliability, identity, or financial standing of Users.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">2.4</span>
						<span>Deviations from these Terms are only valid if agreed upon in writing by The Broker Site.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">2.5</span>
						<span>In case the User applies its own general terms and conditions, such terms are expressly rejected by The Broker Site and shall not apply.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">2.6</span>
						<span>If one or more provisions of these Terms are null and void or subject to annulment, the remaining provisions shall remain in full force and effect. In such case, The Broker Site and the User shall, in mutual consultation, agree on a substitute provision that, to the extent possible, reflects the purpose and intent of the original provision.</span>
					</div>
				</div>
			</div>

			<div>
				<h2 class="text-lg font-bold text-gray-800 mb-3">3. Change of terms</h2>
				<div class="space-y-2 ml-4">
					<div class="flex">
						<span class="font-medium mr-2">3.1</span>
						<span>The Broker Site may amend these Terms at any time.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">3.2</span>
						<span>Users will be informed of any changes in advance. Continued use of the Platform constitutes acceptance of the revised Terms.</span>
					</div>
				</div>
			</div>

			<div>
				<h2 class="text-lg font-bold text-gray-800 mb-3">4. Agreement</h2>
				<div class="space-y-2 ml-4">
					<div class="flex">
						<span class="font-medium mr-2">4.1</span>
						<span>By submitting the Membership Application form, the User acknowledges and accepts the conditions of these Terms as set out below.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">4.2</span>
						<span>Membership entitles the User only to those rights explicitly granted under these Terms.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">4.3</span>
						<span>No rights, including intellectual property rights, of The Broker Site are transferred or licensed to Users.</span>
					</div>
				</div>
			</div>

			<div>
				<h2 class="text-lg font-bold text-gray-800 mb-3">5. Duration and termination</h2>
				<div class="space-y-2 ml-4">
					<div class="flex">
						<span class="font-medium mr-2">5.1</span>
						<span>These Terms are effective upon receipt and acceptance of a Vendor Application Form by The Broker Site.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">5.2</span>
						<span>Membership is entered into for an indefinite period and is billed annually by The Broker Site until either party terminates the agreement. Once billed, membership fees are non-refundable.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">5.3</span>
						<span>The User may terminate the agreement for any reason, or no reason at all, upon written notice to The Broker Site.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">5.4</span>
						<span>The User agrees that Broker Site may suspend or terminate a User's access to the Platform if the User violates these Terms, in particular Article 7, or if The Broker Site, at its sole discretion, deems such termination necessary for business, operational, legal, or other legitimate reasons. The Broker Site shall notify the User of such suspension or termination, however, the act of suspension or termination itself shall be deemed sufficient notice.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">5.5</span>
						<span>Membership fees already invoiced or paid shall not be refunded in the event of suspension or termination.</span>
					</div>
				</div>
			</div>

			<div>
				<h2 class="text-lg font-bold text-gray-800 mb-3">6. Inventory</h2>
				<div class="space-y-2 ml-4">
					<div class="flex">
						<span class="font-medium mr-2">6.1</span>
						<span>The Advertising Party shall update its inventory at least once every 2 weeks. Failure to comply shall authorize The Broker Site to remove the vendor's inventory at its discretion.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">6.2</span>
						<span>All items uploaded to the Platform must be physically in the Advertising Party's own stock and available for immediate sale. Advertising or listing products that are owned by, or sourced from, another party's inventory is strictly prohibited.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">6.3</span>
						<span>The Advertising Party's username and password are strictly confidential and may not be disclosed to non-members under any circumstance.</span>
					</div>
				</div>
			</div>

			<div>
				<h2 class="text-lg font-bold text-gray-800 mb-3">7. Member conduct and content rules</h2>
				<div class="space-y-2 ml-4">
					<div class="flex">
						<span class="font-medium mr-2">7.1</span>
						<span>All listings and communications must accurately represent the User's own business and available inventory, as defined in Article 6.2.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">7.2</span>
						<span>Users agree not to upload, post or distribute any content that is illegal, offensive, or violates public order and decency, including but not limited to:</span>
					</div>
					<ul class="ml-6 space-y-1">
						<li>• Illegal, discriminatory, threatening, defamatory, hateful or other objectionable content;</li>
						<li>• Content that infringes the intellectual property rights of others, including copyrights, trademarks, or other proprietary rights;</li>
					</ul>
					<div class="flex">
						<span class="font-medium mr-2">7.3</span>
						<span>Users shall not use the Platform for any illegal purposes or activities that violate these Terms, including but not limited to spamming, spreading viruses, or unauthorized messaging.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">7.4</span>
						<span>Prohibited conduct includes, but is not limited to:</span>
					</div>
					<ul class="ml-6 space-y-1">
						<li>• Registering with false or disposable email addresses;</li>
						<li>• Placing duplicate or misleading listings;</li>
						<li>• Acting on behalf of third parties without consent of The Broker Site.</li>
					</ul>
					<div class="flex">
						<span class="font-medium mr-2">7.5</span>
						<span>The Broker Site may remove or restrict any content or listing that violates these Terms without prior notice. Removal may also occur if, at The Broker Site's sole discretion, removal is deemed justified. In such case, the User will be informed afterwards of the reason for removal.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">7.6</span>
						<span>Users are fully responsible for all consequences arising from the content they upload.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">7.7</span>
						<span>Users must comply with all applicable trade sanctions, embargoes, export controls and other restrictive measures, including those imposed by the European Union and any other applicable authorities.<br>
						Users may not use the Platform to offer, purchase, sell, supply, export, re export or otherwise facilitate the trade of goods or services where such activity is prohibited by applicable law. This includes transactions involving sanctioned or otherwise restricted countries, territories, entities or individuals.
						<br>
						Each User is solely responsible for ensuring that its transactions are legally permitted and for carrying out appropriate due diligence on its customers, suppliers, end users and destinations.
						<br>
						Any violation of this Article may result in the immediate suspension or termination of the User's membership and access to the Platform.</span>
					</div>
				</div>
			</div>

			<div>
				<h2 class="text-lg font-bold text-gray-800 mb-3">8. Invoices</h2>
				<div class="space-y-2 ml-4">
					<div class="flex">
						<span class="font-medium mr-2">8.1</span>
						<span>All invoices are due and payable 15 days from date of invoice.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">8.2</span>
						<span>If the User fails to fulfil its payment obligations within the agreed period, the User shall be in default by operation of law, without the need for any further notice of default. From the moment of default, the User shall owe the statutory commercial interest under the Dutch law.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">8.3</span>
						<span>All reasonable judicial and extrajudicial collection costs incurred by The Broker Site shall be for the User's account. In the event of late payment, these costs are immediately due and payable.</span>
					</div>
				</div>
			</div>

			<div>
				<h2 class="text-lg font-bold text-gray-800 mb-3">9. Liabilities</h2>
				<div class="space-y-2 ml-4">
					<div class="flex">
						<span class="font-medium mr-2">9.1</span>
						<span>Parties agree that The Broker Site is not liable for losses incurred whether during or resulting from the use or application of the software or the data provided by The Broker Site.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">9.2</span>
						<span>Parties agree that The Broker Site is not liable for any direct, indirect, special, incidental, or consequential damages, whether based on contract, tort or any other legal theory, arising out of the sale, service, furnishing performance or use of any information, data or materials sold or provided under the agreement, including any operational or technical errors.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">9.3</span>
						<span>The Advertising Party shall indemnify and hold harmless The Broker Site from any and all such damages and/or related claims.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">9.4</span>
						<span>In the event of any dispute, claim, or conflict between Users of the Platform, each User acknowledges and agrees that such dispute is solely between the respective Users. Users shall indemnify and hold harmless The Broker Site from any liability, damages, losses, costs, or expenses arising out of or related to disputes between Users, including but not limited to claims regarding the performance, quality, or delivery of products or services.</span>
					</div>
				</div>
			</div>

			<div>
				<h2 class="text-lg font-bold text-gray-800 mb-3">10. Mediation and complaints</h2>
				<div class="space-y-2 ml-4">
					<div class="flex">
						<span class="font-medium mr-2">10.1</span>
						<span>The Broker Site may, at its sole discretion or upon request of a User, facilitate communication or mediation between Users in the event of a dispute. Such facilitation or mediation is provided solely as a courtesy service and does not create any obligation, warranty, or liability for The Broker Site. Users remain fully responsible for resolving their disputes.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">10.2</span>
						<span>Notwithstanding the foregoing, Users may file a formal complaint against another Member through the Platform. To do so, the User must navigate to the member's company profile on TBS and click the "File Complaint" button. The complaint must include a concise and factual description of the issue, together with copies of both the Purchase Order (PO) and Invoice. The quality or grade of the goods must be clearly stated on these documents; complaints lacking this information will not be processed.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">10.3</span>
						<span>The Broker Site does not mediate or process complaints concerning C-grade or D-grade hardware, transactions valued below €2,000, goods sold "As Is," or software transactions. Users are strongly advised to purchase "As Is" items only from companies with whom they maintain an established and long-term business relationship.</span>
					</div>
				</div>
			</div>

			<div>
				<h2 class="text-lg font-bold text-gray-800 mb-3">11. Intellectual property and copyright</h2>
				<div class="space-y-2 ml-4">
					<div class="flex">
						<span class="font-medium mr-2">11.1</span>
						<span>All intellectual property rights, including but not limited to copyrights, database rights, design rights, trade names, and trademarks, in and to the Platform, its layout, software, logos, text, images, and all other materials made available by The Broker Site, are and shall remain the exclusive property of The Broker Site.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">11.2</span>
						<span>Users are granted a limited, non-exclusive, non-transferable, and revocable right to access and use the Platform solely for the purposes of listing, buying, or selling products in accordance with these Terms. No part of the Platform or its content may be copied, reproduced, modified, distributed, transmitted, displayed, performed, published, or otherwise exploited without the prior written consent of The Broker Site.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">11.3</span>
						<span>Users retain ownership of all information and materials ("User Content") that they upload to the Platform. By submitting or posting such User Content, the User grants The Broker Site a worldwide, non-exclusive, sublicensable, and transferable license to use, host, reproduce, display, and distribute the User Content as necessary for operating and improving the Platform and related services.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">11.4</span>
						<span>Users warrant that their uploaded or listed content does not infringe any third-party intellectual property rights, including copyrights, trademarks, patents, or trade secrets. Users shall fully indemnify and hold harmless The Broker Site from and against any and all claims, losses, or damages arising from alleged or actual infringement of third-party rights.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">11.5</span>
						<span>All rights not expressly granted in these Terms are reserved by The Broker Site. Unauthorized use of any content or materials from the Platform may result in civil and/or criminal liability under applicable intellectual property laws.</span>
					</div>
				</div>
			</div>

			<div>
				<h2 class="text-lg font-bold text-gray-800 mb-3">12. Privacy</h2>
				<div class="space-y-2 ml-4">
					<div class="flex">
						<span class="font-medium mr-2">12.1</span>
						<span>The personal data received by The Broker Site for the purpose of providing the services will be processed and stored by The Broker Site in accordance with the "Algemene Verordening Gegevensbescherming" (General Data Protection Regulation (GDPR)). For more information, please refer to the <a href="/privacy" target="_blank" rel="noopener" class="text-red-700 hover:underline">Privacy and Cookies Policy</a> available on The Broker Site's website.</span>
					</div>
				</div>
			</div>

			<div>
				<h2 class="text-lg font-bold text-gray-800 mb-3">13. Governing law and disputes</h2>
				<div class="space-y-2 ml-4">
					<div class="flex">
						<span class="font-medium mr-2">13.1</span>
						<span>The agreement is entered into at Breda, The Netherlands and shall be governed by laws of The Netherlands.</span>
					</div>
					<div class="flex">
						<span class="font-medium mr-2">13.2</span>
						<span>All disputes between The Broker Site and a User to which these general terms and conditions apply shall be settled by the Court of Zeeland-West-Brabant, location Breda, The Netherlands, unless a mandatory provision of law dictates otherwise.</span>
					</div>
				</div>
			</div>

			<div>
				<p class="mt-6">The Broker Site is located at Ginnekenweg 272, 4835 NK Breda, registered with the Dutch Chamber of Commerce under number 20094175 (KvK-nummer).</p>
			</div>

		</div>
	</div>
</template>

<script>

export default {
  name: 'ContractComponent',
}
</script>